export function wrapAugmentationModelFB (data) {
    if (data.action_type === 'template' || data.action_type === 'templates') {
        data.action_type = 'story';
    }
    if (data.images) {
        data.imgs = [...data.images];
        delete data['images'];
    }
    return data;
}

export function wrapAugmentationModelBF (data) {
    if (data.action_type === 'template' || data.action_type === 'templates') {
        data.action_type = 'story';
    }
    if (data.imgs) {
        data.images = [...data.imgs];
        delete data['imgs'];
    }
}
